import {app} from '../../app';

app.component('spOk', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./sp-ok.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-ok/sp-ok.component.js